<script>
/**
 * Dashboard Component
 */
export default {
  props: {
    validations: Object,
  },
  computed: {
    isError() {
      if (this.validations != null) {
        return this.validations.$error;
      } else {
        return false;
      }
    },
  },
};
</script>

<template>
  <div v-if="isError" class="invalid-tooltip">
    <span v-if="validations.required != undefined && !validations.required">
      {{ $t('errors.requiredValue') }}
    </span>
    <span
      v-else-if="validations.minLength != undefined && !validations.minLength"
    >
      {{
        $t('errors.minLength').replace('#', validations.$params.minLength.min)
      }}
    </span>
    <span
      v-else-if="validations.minValue != undefined && !validations.minValue"
    >
      {{ $t('errors.minValue').replace('#', validations.$params.minValue.min) }}
    </span>
    <span
      v-else-if="validations.maxValue != undefined && !validations.maxValue"
    >
      {{ $t('errors.maxValue').replace('#', validations.$params.maxValue.max) }}
    </span>
    <span v-else-if="validations.integer != undefined && !validations.integer">
      {{ $t('errors.noDecimal') }}
    </span>
    <span v-else-if="validations.between != undefined && !validations.between">
      {{
        $t('errors.valueBetween')
          .replace('#', validations.$params.between.min)
          .replace('$', validations.$params.between.max)
      }}
    </span>
    <span v-else>
      {{ $t('errors.formatNotValid') }}
    </span>
  </div>
</template>

<style scoped>
.invalid-tooltip {
  width: 100%;
  text-align: center;
  border-radius: 0 0 5px 5px;
}
</style>